import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const CAIXA_SEGMENTADA = {
    display: "inline-flex",
    border: "1px solid var(--border-strong)",
    borderRadius: 10,
    padding: 2,
    gap: 2,
    background: "var(--surface)",
};
export function FilterChips({ label, value, options, onChange, variant = "solto" }) {
    const segmentado = variant === "segmentado";
    return (_jsxs("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }, children: [label ? (_jsxs("span", { style: { fontSize: 13, color: "var(--text-muted)", minWidth: 62 }, children: [label, ":"] })) : null, _jsx("div", { style: segmentado ? CAIXA_SEGMENTADA : { display: "contents" }, children: options.map((o) => {
                    const ativo = o.value === value;
                    const cor = o.cor ?? "var(--accent)";
                    return (_jsxs("button", { type: "button", onClick: () => onChange(o.value), "aria-pressed": ativo, style: segmentado
                            ? {
                                padding: "6px 14px",
                                borderRadius: 8,
                                cursor: "pointer",
                                fontSize: 12.5,
                                whiteSpace: "nowrap",
                                border: "1px solid transparent",
                                background: ativo ? `color-mix(in srgb, ${cor} 16%, transparent)` : "transparent",
                                color: ativo ? "var(--text)" : "var(--text-muted)",
                                fontWeight: ativo ? 700 : 500,
                            }
                            : {
                                padding: "5px 11px",
                                borderRadius: 999,
                                cursor: "pointer",
                                fontSize: 12.5,
                                whiteSpace: "nowrap",
                                border: `1px solid ${ativo ? cor : "var(--border)"}`,
                                background: ativo ? `color-mix(in srgb, ${cor} 16%, transparent)` : "var(--surface)",
                                color: ativo ? "var(--text)" : "var(--text-muted)",
                                fontWeight: ativo ? 700 : 500,
                            }, children: [o.label, o.count !== undefined ? (_jsxs("span", { style: { marginLeft: 5, opacity: 0.75 }, children: ["(", o.count.toLocaleString("pt-BR"), ")"] })) : null] }, o.value || "__todas__"));
                }) })] }));
}
//# sourceMappingURL=FilterChips.js.map